export default __webpack_public_path__ + "static/media/ck.b7eb3e9d.svg";